<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-9">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">{{ lista_campos != '' ? 'Editar' : 'Crear' }} Examen</h3>
        </div>
        <div class="card-body">
          <div class="form">
            <div class="form-group row">
              <div class="col-md-8">
                <label class="col-md-12">{{ $t('EXAMES.NOME') }}:*</label>
                <input required type="text" class="form-control" v-model="form.nome"
                  placeholder="Digite el nombre..." />
              </div>
              <div class="col-md-4">
                <label class="col-md-12">Codigo:*</label>
                <input required type="text" class="form-control" v-model="form.codigo"
                  placeholder="min(2 caracteres)..." />
              </div>

            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label class="col-md-12">{{ $t('EXAMES.TIPO_EXAME') }}:*</label>
                <treeselect v-model="form.tipo_exame_id" :multiple="false" :options="lista_tipo_exames" />
              </div>
              <div class="col-md-4">
                <label class="col-md-12">{{ $t('EXAMES.TIPO_AMOSTRA') }}:*</label>
                <treeselect v-model="form.tipo_amostra_id" :multiple="false" :options="lista_tipo_amostras" />
              </div>
             
              <div class="col-md-4">
                <label class="col-md-12">{{ $t('EXAMES.PRECO') }}(G$)</label>
                <input required type="text" class="form-control" v-model="form.preco"
                  placeholder="Descripción(opcional)..." />
              </div>

            </div>
            <div class="form-group row">
             
              <div class="col-md-12">
                <label class="col-md-12">{{ $t('DESCRICAO.NOME') }}*</label>
                <input required type="text" class="form-control" v-model="form.descricao"
                  placeholder="Descripción(opcional)..." />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-center">
                <button @click="confirm(lista_campos == '' ? 'cria' : 'edita')" class="btn btn-primary"
                  :disabled="verif">
                  {{ $t('GERENCIAR.NOME') }}
                  <b-spinner v-show="verif" small variant="dark" type="grow" label="Spinning"></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { fireAlert } from "@/core/mixins/alertMessageMixin";

export default {
  mixins: [fireAlert],
  data() { 
    return {
      form: {
        nome: "",
        codigo: "",
        descricao: "",
        preco: "",
        tipo_exame_id: null,
        tipo_amostra_id: null,
        entrega: ""
      },
      verif: false,
    };
  },
  created() {
    this.preenxerCampos();
  },
  computed: {

    lista_filials() {
      return this.$store.state.configEmpresa.lista_filials;
    },
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    lista_tipo_exames() {
      return this.$store.state.tipo_exame.lista_tipo_exames;
    },
    lista_tipo_amostras() {
      return this.$store.state.tipo_amostra.lista_tipo_amostras;
    },
    mensagem_alert() {
      return this.$store.state.exame.mensagem_alert;
    },
  },
  methods: {
    async listar_tipo_exames() {
      this.$store.dispatch("configEmpresa/MudarPreloader", true);
      await this.$store
        .dispatch("tipo_exame/listar_tipo_exames_ativos")
        .finally(() => {
          this.$store.dispatch("configEmpresa/MudarPreloader", false);
        });
    },
    async listar_tipo_amostra(){
      await  this.$store.dispatch("tipo_amostra/listar_tipo_amostras");
    },
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação  ` + tipo + ` uma exame no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("exame/create_exame", this.form)
        .finally(() => {
          this.verif = false
          this.alertError()
        });  
    },

    async update() {
      this.verif = true;
      const dados = {
        id: this.lista_campos.id,
        nome: this.form.nome,
        descricao: this.form.descricao,
        codigo: this.form.codigo,
        preco: this.form.preco,
        tipo_exame_id: this.form.tipo_exame_id,
        tipo_amostra_id:this.form.tipo_amostra_id,
        entrega: this.form.entrega
      }
      await this.$store.dispatch("exame/update_exame", dados)
        .finally(() => {
          this.verif = false
          this.alertError()
        });

    },

    preenxerCampos() {
      this.listar_tipo_exames()
      this.listar_tipo_amostra()
      if (this.lista_campos != "")
        this.form = {
          id: this.lista_campos.id,
          nome: this.lista_campos.nome,
          codigo: this.lista_campos.codigo,
          descricao: this.lista_campos.descricao,
          tipo_amostra_id: this.lista_campos.tipo_amostra_id,
          tipo_exame_id: this.lista_campos.tipo_exame_id,
          preco: this.lista_campos.preco
        };
    },

    alertError() {
      console.log(this.mensagem_alert);
      if (this.mensagem_alert.tipo == "error") {
        let texto = "";
        const erros = this.mensagem_alert.message.errors;
        console.log("erros", erros);

        for (const campo in erros) {
          if (erros.hasOwnProperty(campo)) {
            texto += `<b>${campo.toUpperCase()}</b>:\n`;
            erros[campo].forEach((erro, index) => {
              texto += `  ${index + 1}. ${erro}\n`;
            });
            texto += "\n";
          }
        }

        Swal.fire({
          title: 'Verificar los campos!',
          html: texto.replace(/\n/g, '<br>'),
          confirmButtonText: "Terminar de llenar",
          confirmButtonColor: '#ff6060',
        });
      } else {
        this.fireAlert(this.mensagem_alert.message);
        this.$router.push({ name: "listaExames" });
      }
    },

    
    fomatarGuarani(valor) {
      const input = valor.replace(/[^\d]/g, ""); // remove tudo que não for número
      const value = Number.parseInt(input, 10);
      const formatted = new Intl.NumberFormat("es-PY", {
        style: "currency",
        currency: "PYG",
        currencyDisplay: "symbol",
      }).format(value);
      return formatted;
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgb(167, 183, 255);
}
</style>